/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';

import { getDetailUpload } from '@actions/users'

class DetailUploadModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      justification: '',
      detailupload: null,
      errors: []
    }
  }
  
  async componentDidMount () {
    const { data, getDetailUpload } = this.props
    console.log('Data', data)
    const response = await getDetailUpload(data)
    if (!response?.status) {
      this.setState({detailupload: response.data})
    }
  }

  onSubmit = async (action) => {
    // e.preventDefault();
    const { data, onChahneLoadingBtn } = this.props
    onChahneLoadingBtn(true)
    const { justification } = this.state
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return onChahneLoadingBtn(false)
    return action(data, justification)
  }

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFieldsReject = async () => {
    const { t } = this.props
    const { justification } = this.state
    let errors = {}
    if (!justification) errors = { ...errors, 'justification': `${t('Justificación del cambio')} ${t('es requerido')}`}

    this.setState({errors})
    return errors
  }

  render () {
    const { t, onHidden, data, suspendAction, reactiveAction } = this.props
    const { errors, loadingPage, detailupload } = this.state
    
    const isFormFieldValid = (name) =>
    !!(errors[name]);
  
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );


    const children = (
      <div className="p-grid p-mt-2 p-fluid" >
        <div className="p-col-12">
            ¿Estas seguro que deseas ejecutar el proceso de carga?
        </div>
        <div className="p-col-6 p-text-right p-text-bold">
          {t('Total de registros')}:
        </div>
        <div className="p-col-6 p-pl-3">
          {detailupload?.total}
        </div>
        <div className="p-col-6 p-text-right p-text-bold">
          {t('Altas')}:
        </div>
        <div className="p-col-6 p-pl-3">
          {detailupload?.altas}
        </div>
        <div className="p-col-6 p-text-right p-text-bold">
          {t('Bajas')}:
        </div>
        <div className="p-col-6 p-pl-3">
          {detailupload?.bajas}
        </div>
        <div className="p-col-6 p-text-right p-text-bold">
          {t('Actualizaciones')}:
        </div>
        <div className="p-col-6 p-pl-3">
          {detailupload?.actualiza}
        </div>
        <div className="p-col-12">
          <label className="p-text-bold">{t('Justificación del cambio')}</label>
          <InputTextarea
            name="justification"
            onChange={(e) =>
              this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
            }
            rows={5}
            cols={30}
            className={classNames({
              'p-invalid': isFormFieldValid(`justification`),
            })}
          />
          {getFormErrorMessage(`justification`)}
        </div>
        <div className="p-col-12 p-dialog-footer custom">
          <div className="p-d-flex p-jc-sm-between">
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">{t('Cerrar')}</span>
            </button>
            <div>
              {/* <button className="p-button p-button-danger p-component" onClick={() => this.onSubmit(suspendAction)}>
                <span className="p-button-label p-c">{t('Suspender carga')}</span>
              </button> */}
              {/* <button className="p-button p-button-success p-component" onClick={() => this.onSubmit(reactiveAction)}>
                <span className="p-button-label p-c">{t('Ejecutar carga')}</span>
              </button> */}
              <Button
                label={t('Suspender carga')}
                className="p-button p-button-danger p-component"
                onClick={() => this.onSubmit(suspendAction)}
                loading={this.props.loadingBtn}
              />
              <Button
                label={t('Ejecutar carga')}
                className="p-button p-button-success p-component"
                onClick={() => this.onSubmit(reactiveAction)}
                loading={this.props.loadingBtn}
              />
            </div>
          </div>
        </div>
      </div>
    )

    return (
      <Dialog
        header={t('Datos del usuario')}
        visible
        breakpoints={{'960px': '90vw'}}
        style={{ width: '40vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}

const mapDispatchToProps = {
  getDetailUpload,
};

export default compose(withTranslation(), connect(null, mapDispatchToProps))(DetailUploadModal)